import React from 'react';
import { Box, Text, Button, Image, Heading } from '@wix/design-system';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common';
import style from './wix-capital-dealer-banner.module.scss';

export interface WixCapitalDealerBannerAssets {
  titleText?: string;
  subtitleText?: string;
  ctaText?: string;
  logoUrl?: string;
}

export interface WixCapitalDealerBannerProps {
  assets?: WixCapitalDealerBannerAssets;
  parsedCtaUrl?: string;
  onPrimaryCtaClick: () => void;
}

export function WixCapitalDealerBanner({
  assets,
  parsedCtaUrl,
  onPrimaryCtaClick,
}: WixCapitalDealerBannerProps) {
  if (!assets) {
    return null;
  }

  return (
    <Box
      marginTop="SP6"
      width="100%"
      borderRadius="8px"
      className={style.bannerContainer}
    >
      <Box
        width="100%"
        verticalAlign="middle"
        gap="SP3"
        padding="SP4 SP6 SP4 SP6"
        justifyItems="space-between"
      >
        <Box direction="vertical" gap="SP1">
          <Heading size="medium" weight="bold">
            {assets.titleText}
          </Heading>
          <Box maxWidth="610px">
            <Text size="small">{assets.subtitleText}</Text>
          </Box>
          <Box marginTop="SP2">
            <Button
              size="small"
              as="a"
              href={parsedCtaUrl}
              skin="dark"
              target="_blank"
              onClick={onPrimaryCtaClick}
              prefixIcon={<ExternalLinkSmall />}
            >
              {assets.ctaText}
            </Button>
          </Box>
        </Box>
        <Box marginLeft="auto">
          {assets.logoUrl && (
            <Box width="280px">
              <Image transparent={true} src={assets.logoUrl} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
